import * as React from "react";
import {
  Button,
  ColorPicker,
  COLOR_PICKER_PRESETS,
  hexToHSV,
  readableTextColor,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ColorPickerDemo() {
  // One controlled hex string drives both the inline picker and the live
  // readout swatch, so the value, the HSV math, and the in-contrast label all
  // move together.
  const [color, setColor] = React.useState("#0a2540");
  // A second, independent value backs the popover trigger.
  const [popColor, setPopColor] = React.useState("#10B981");

  const hsv = hexToHSV(color);

  return (
    <Section
      id="color-picker"
      title="ColorPicker"
      description="One accessible HSV color picker for the platform, built on react-colorful (pointer + touch + keyboard) and re-skinned to brand tokens. Adds a branded hex field, an optional eyedropper, and a preset row; ColorPicker.Popover folds it into the brand <Popover>. Color math (hexToHSV / readableTextColor / ...) lives in the shared colorUtils helper."
    >
      <VariantBlock label="Default" caption="uncontrolled, seeded from defaultValue, with the default presets">
        <ColorPicker defaultValue="#daa520" />
      </VariantBlock>

      <VariantBlock label="Controlled + colorUtils" caption="value / onChange; the readout uses hexToHSV and readableTextColor">
        <div className="flex flex-col gap-3">
          <ColorPicker value={color} onChange={setColor} presets={COLOR_PICKER_PRESETS} />
          <div
            className="flex items-center justify-between rounded-md border border-border px-3 py-2 font-mono text-sm"
            style={{ backgroundColor: color, color: readableTextColor(color) }}
          >
            <span className="uppercase">{color}</span>
            <span>
              h {hsv.h} · s {hsv.s} · v {hsv.v}
            </span>
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="In a popover" caption="ColorPicker.Popover — controlled, springs in on open">
        <ColorPicker.Popover value={popColor} onChange={setPopColor}>
          <Button variant="outline">
            <span
              aria-hidden
              className="size-4 rounded-full border border-border/40"
              style={{ backgroundColor: popColor }}
            />
            <span className="font-mono uppercase">{popColor}</span>
          </Button>
        </ColorPicker.Popover>
      </VariantBlock>

      <VariantBlock label="Compact, no presets" caption="size='sm' (140px square), presets={[]} hides the row">
        <ColorPicker size="sm" defaultValue="#8B5CF6" presets={[]} />
      </VariantBlock>
    </Section>
  );
}
